import * as actionTypes from './actionTypes';

export const onCheckNRICSessionSuccess = (payload)=> ({
    type: actionTypes.CHECK_NRIC_SESSION_SUCCESS,
    payload
});

export const onCheckNRICSessionFailed = (error) => ({
    type: actionTypes.CHECK_NRIC_SESSION_FAILED,
    payload : {
        errorNricValid: error.msg
    }
});

export const checkNricSessionStart  = (nricNo,sessionId) =>({
    type: actionTypes.CHECK_NRIC_SESSION,
    nricNo,
    sessionId
});